import {AbstractPayment, OvereasProcessor} from "./OvereasProcessor";
import {WebHelpers} from "./WebHelpers";
import {AbstractModule} from "./AbstractModule";

interface TrackinInfo {
    g: string; // the chosen gateway for this user
}

/**
 * Class to interact with the Woocommerce store of a WordPress installation.
 */
export class Woocommerce extends AbstractModule {
    protected static readonly COOKIE_NAME = "ospay";
    protected static readonly COOKIE_LIFETIME_DAYS = 365;

    constructor(plugin: OvereasProcessor, webHelpers: WebHelpers) {
        super(plugin, webHelpers);
        this.plugin.$(this.plugin.window.document).ready(($) => {
            if (this.plugin.$("#overs-payment-frame, #overs-payment-button, #payment.woocommerce-checkout-payment").length !== 0) {
                //this.addButtonEvents();
                this.ensureCookiePresence();
                this.addPaymentTacking();
            }
        });
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    /*
    protected addButtonEvents() {
        this.plugin.$("#overs-payment-button").on("click", (event) => {
            console.log("pay")
            this.plugin.window.open()
        });
    }
     */

    /**
     * Adds a cookie to remember the customer's payment option.
     */
    protected addPaymentTacking() {
        if (typeof this.plugin.window.btoa !== "function" || this.plugin.getConfig().gateway === undefined)
            return;
        let data: TrackinInfo = {
            g: this.plugin.getConfig().gateway
        }
        const dataEncoded = this.webHelpers.serializeBase64Data(data);
        this.webHelpers.setCookie(Woocommerce.COOKIE_NAME, dataEncoded, Woocommerce.COOKIE_LIFETIME_DAYS);
        this.plugin.window.localStorage.setItem(Woocommerce.COOKIE_NAME, dataEncoded);
    }

    protected readTrackingInfo(onlyCookie: boolean = false): TrackinInfo {
        if (typeof this.plugin.window.btoa !== "function")
            return null;
        let cookie = this.webHelpers.getCookie(Woocommerce.COOKIE_NAME);
        if (cookie) {
            let cookieUnserialized = this.webHelpers.unserializeBase64Data(cookie);
            if (cookieUnserialized)
                return cookieUnserialized;
        }
        if (onlyCookie === true)
            return null;
        let localStorageData = this.plugin.window.localStorage.getItem(Woocommerce.COOKIE_NAME);
        if (localStorageData) {
            let localStorageUnserialized = this.webHelpers.unserializeBase64Data(localStorageData);
            if (localStorageUnserialized)
                return localStorageUnserialized;
        }
        return null;
    }

    protected ensureCookiePresence() {
        // our backend only reads the cookie on Ajax requests
        // restore previous data from localStorage
        let info = this.readTrackingInfo();
        if (!info || !info.g)
            return;
        let infoCookie = this.readTrackingInfo(true);
        if (this.plugin.getConfig().gateway !== undefined && infoCookie.g === this.plugin.getConfig().gateway)
            return;
        let data: TrackinInfo = {
            g: info.g
        }
        const dataEncoded = this.webHelpers.serializeBase64Data(data);
        this.webHelpers.setCookie(Woocommerce.COOKIE_NAME, dataEncoded, Woocommerce.COOKIE_LIFETIME_DAYS);
    }
}
